/* klar-features-highlight.js */

(function () {
  document.querySelectorAll(".klar-fh__animated-word").forEach(function (el) {
    var raw = el.dataset.words || "";
    var words = raw
      .split("|")
      .map(function (w) {
        return w.trim();
      })
      .filter(Boolean);
    if (words.length < 2) return;

    var current = 0;

    setInterval(function () {
      el.classList.add("is-fading");
      setTimeout(function () {
        current = (current + 1) % words.length;
        el.textContent = words[current];
        el.classList.remove("is-fading");
      }, 260);
    }, 2600);
  });
})();
